import React, { useEffect } from "react"
import Select from 'react-select';
import { useState } from "react";
import TextTruncate from "../utilsComponent/textTruncate";
import Form from 'react-bootstrap/Form';
import { editModeOn, encryptValue, firstLetterCapital, getFromDecreaptLocalStorage, removeFromLocalStorage, saveInLocalStorage } from "../utilFunctions";
import CreateRole from "./createRole";
import UpdateRole from "./updateRole";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT, REACT_APP_VAM_ENDPOINT } from "../urls";
import LoadingPage from "../reusableComponents/loader/loadingPage.jsx";
import NoDataFound from "../utilsComponent/noDataFound.jsx";
import { axiosRequest } from "../service.js";
import { functionalities, functionalityOrder, PAGE_NAME_KEYS } from "../consts.js";



const RoleMaster = (props) => {
  const {roleDataCookie} = props
  const navigate = useNavigate()
  const location = useLocation();
  const [rolesList, setRolesList] = useState([])
  const [functionalityList, setFunctionalityList] = useState([])
  const [roleData, setRoleData] = useState({})
  const [sortedDescription, setSortedDescription] = useState(false)
  const [sortedStatus, setSortedStatus] = useState(false)
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [selectedPage, setSelectedPage] = useState(0)
  const [searchMode, setSearchMode] = useState(false)
  const defaultSearch = {
    roleID: "",
    roleName: "",
    status: null
  }
  const [searchData, setSearchData] = useState(defaultSearch)
  const [openDropDown, setOpenDropDown] = useState(false)  
  const [loading, setLoading]=useState(false)
  const cmsStatusListCookies = getFromDecreaptLocalStorage("CMSstatusList")
  


  useEffect(() => {
    // if(roleDataCookie?.roleName !== "Admin" || !roleDataCookie?.roleName){
    //   toast.error("You are not authorized to view this page.")
    //   navigate({
    //     pathname: '/dashboard/claim_intimation',
    //     // search: "user=chandana.k@kshema.co",
    // });
    // }
    getRolesdata()
    getFunctionalityListdata()
    return () => {
      removeFromLocalStorage("rolemaster")   
    }
  },[])


  const getRolesdata = () => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/roles`).then(data => {
      setRolesList(data.data)
    }).catch(error => {
      console.log(error)
    })
  }
  const getSearchRolesdata = () => {
    if(searchData.roleID== ""&&searchData.roleName== ""&&(searchData.status== ""||searchData.status== null))
      {
        toast.error("Please Input a search Parameter");
        return;
    }
    setLoading(true)
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/rolesSearch?roleID=${searchData.roleID}&roleName=${searchData.roleName}&status=${searchData.status == null ? "" : searchData.status.value}`).then(data => {
      setRolesList(data.data)
      setSearchMode(true)
      setSelectedPage(0)
      setItemOffset(0)
      setLoading(false)
    }).catch(error => {
      console.log(error)
    })
  }
  const getFunctionalityListdata = () => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/functionalities`).then(data => {
      setFunctionalityList(sortedFunctionalities(data.data))
    }).catch(error => {
      console.log(error)
    })
  }
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(rolesList.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(rolesList.length / itemsPerPage));
  }, [itemOffset, itemsPerPage,rolesList]);



  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage % rolesList.length;
    setItemOffset(newOffset);
    setSelectedPage(event.selected)
  };

  const navigateToCreateRole = () => {
    navigate(`/dashboard/${PAGE_NAME_KEYS.ROLE_MASTER}/${PAGE_NAME_KEYS.CREATE_ROLE}`)
    setRoleData({})
  };

  // Sort the functionalities based on order
  const sortedFunctionalities = (functionalityList = []) => {
    return functionalityList.sort((a,b) => functionalityOrder[a.functionalityName]-functionalityOrder[b.functionalityName])
  }
  const navigateToUpdateRole = (data) => {
    axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_ROLE_MANAGMENT}/role/${data.roleID}`).then(data => {
      // sort the functionalities based on order
      if(data?.data?.roleFunctionalities?.length) {
        data.data.roleFunctionalities = sortedFunctionalities(data.data.roleFunctionalities)
      }
      let roleDataEncripted = encryptValue(JSON.stringify(data.data))
      saveInLocalStorage("rolemaster", roleDataEncripted)   
      navigate(`/dashboard/${PAGE_NAME_KEYS.ROLE_MASTER}/${PAGE_NAME_KEYS.EDIT_ROLE}`)
      setRoleData(data.data)
    }).catch(error => {
      console.log(error)
    })
  };
  const navigateToRoleMater = (data) => {
    navigate(`/dashboard/${PAGE_NAME_KEYS.ROLE_MASTER}`)
  };
  const functionalityName = (data) => {
    if (functionalityList.length > 0) {
      const selectedList = functionalityList.filter(list => list.functionalityID == data.functionId)
      if (selectedList.length > 0) {
        return selectedList[0].functionalityName
      } else {
        return ""
      }
    } else {
      return ""
    }
  }
  const sortDescription = () => {
    if (!sortedDescription) {
      const lists = [...rolesList]
      lists.sort((a, b) => a.roleDescription.toLowerCase().localeCompare(b.roleDescription.toLowerCase()))
      setRolesList([...lists])
      setSortedDescription(true)
    } else {
      const lists = [...rolesList]
      lists.sort((a, b) => b.roleDescription.toLowerCase().localeCompare(a.roleDescription.toLowerCase()))
      setRolesList([...lists])
      setSortedDescription(false)
    }
  }
  const sortStatus = () => {
    if (!sortedStatus) {
      const lists = [...rolesList].map(list => {
        return {
          ...list,
          status: list.status == 1 ? "active" : "inactive"
        }
      })
      lists.sort((a, b) => a.status.localeCompare(b.status))
      setRolesList([...lists].map(list => {
        return {
          ...list,
          status: list.status == "active" ? 1 : 0
        }
      }))
      setSortedStatus(true)
    } else {
      const lists = [...rolesList].map(list => {
        return {
          ...list,
          status: list.status == 1 ? "active" : "inactive"
        }
      })
      lists.sort((a, b) => b.status.localeCompare(a.status))
      setRolesList([...lists].map(list => {
        return {
          ...list,
          status: list.status == "active" ? 1 : 0
        }
      }))
      setSortedStatus(false)
    }
  }
  const getPathName = () => {
    return location.pathname.split("/")[location.pathname.split("/").length - 1]
  }
  const itemPerChangeHandler = (count) => {
    setItemsPerPage(count)
    setItemOffset(0)
    setSelectedPage(0)
  }
  const resetSearch = () => {
    setSearchData(defaultSearch)
    getRolesdata()
  }

  return (
    <div>
      <header>
        <h2 className="ms-4 heading-roleMaster" style={{ color: "black", display: "flex" }}>Role Master</h2>
      </header>      
      <hr />
      {
        getPathName() == PAGE_NAME_KEYS.EDIT_ROLE && (
          <UpdateRole
            navigateToRoleMater={navigateToRoleMater}
            functionalityList={functionalityList}
            roleData={roleData}
            setOpenDropDown={setOpenDropDown}
            functionalityName={functionalityName}
            setRoleData={setRoleData}
            getRolesdata={getRolesdata}
            getFunctionalityListdata={getFunctionalityListdata}
            roleDataCookie={roleDataCookie} />
        )
      }
      {
        getPathName() == PAGE_NAME_KEYS.CREATE_ROLE && (
          <CreateRole
            navigateToRoleMater={navigateToRoleMater}
            functionalityList={functionalityList}
            setOpenDropDown={setOpenDropDown}
            getRolesdata={getRolesdata}
            getFunctionalityListdata={getFunctionalityListdata} />
        )
      }

      {getPathName() === PAGE_NAME_KEYS.ROLE_MASTER? <section className="p-4">
        <h5>Search</h5>
        <div className="border rounded p-4 px-1">
          <div className="d-flex align-items-center justify-content-around row">
            <div className="form-group col-md-4">
              <label for="exampleInputPassword1">Role Name</label>
              <input type="text" className="form-control bg-gray mt-2" id="exampleInputPassword1" placeholder="Enter Role Name" onChange={(e) => setSearchData({ ...searchData, roleName: e.target.value })} value={searchData.roleName} />
            </div>
            <div className="form-group col-md-4">
              <label for="exampleInputPassword2">Role ID</label>
              <input type="text" className="form-control bg-gray mt-2" id="exampleInputPassword2" placeholder="Enter Role ID" onChange={(e) => setSearchData({ ...searchData, roleID: e.target.value })} value={searchData.roleID}/>
            </div>
            <div className="form-group col-md-3">
              <label for="exampleInputPassword8">Role Status</label>
              <Select
                options={cmsStatusListCookies.map((list, index) => {
                  return { label: firstLetterCapital(list.name), value: list.id }
                })}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                  option: (provided) => ({
                    ...provided,
                    cursor: 'pointer',
                  }),
                }}
                value={searchData?.status !== null ? {label: searchData.status.label} : null}
                id="exampleInputPassword8"
                onChange={(data) => data ? setSearchData({ ...searchData, status: data }) : setSearchData({ ...searchData, status: null })}
                classNamePrefix="bg-gray"
                isClearable={true}
                placeholder="Select Role Status" />
            </div>
          </div>
          <div className="form-group">
            <button className="btn btn-success m-4 mb-0 px-4" onClick={() => getSearchRolesdata()}>Search</button>
            <button className="btn btn-outline-success mt-4 mb-0 px-4" onClick={() => resetSearch()}>Reset</button>
          </div>
        </div>
      </section> : null}
      {getPathName() === PAGE_NAME_KEYS.ROLE_MASTER ? <hr /> : null}
      {loading&&(<LoadingPage></LoadingPage>)}
      {!loading&&getPathName() === PAGE_NAME_KEYS.ROLE_MASTER ?
        <section className="p-4 table-responsive">
          <div className="d-flex justify-content-between">
            <h5>{(searchMode && currentItems && currentItems.length > 0) && 'Search Results'}</h5>
            {editModeOn(functionalities.ROLE_MASTER_TAB) && (
            <div className="btn btn-success" onClick={() => {navigateToCreateRole();setOpenDropDown(false)}}>Create Role</div>
            )}
          </div>
          {
            currentItems && currentItems.length > 0 ? (
              <table className="table table-strip mt-3 text-start">
                <thead>
                  <tr>
                    <th scope="col">Role ID</th>
                    <th scope="col">Role Name</th>
                    <th scope="col">Role Description <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer" onClick={() => sortDescription()} width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                  </svg></a></th>
                    <th scope="col">Status <a className="pointer text-body"><svg xmlns="http://www.w3.org/2000/svg" className="pointer" onClick={() => sortStatus()} width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                    <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                  </svg></a></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    currentItems && currentItems.length > 0 ? currentItems.map(role => (
                    <tr>
                      <td><a onClick={() => {setOpenDropDown(false);navigateToUpdateRole(role)}} className="text-success pointer">{role.roleID}</a></td>
                      <td><TextTruncate text={role.roleName} length={15}/></td>
                      <td><TextTruncate text={role.roleDescription} length={20}/></td>
                      <td className={(role.status == "Active" || role.status == "1")  ? `text-success` : (role.status == "Inactive" || role.status == "0") ? 'text-muted' : 'text-primary'}>{role.status == 1 ? "Active" : "Inactive"}</td>
                    </tr>
                    )) :  <tr>
                    <td align="center" colspan="6">No Data Found</td>
                </tr>
                  }
                </tbody>
              </table>
            ) :  <NoDataFound text={"No data Found"}/>
          }
          {
            rolesList.length > 0 && (
              <div className="d-flex align-items-center justify-content-end">
                <div className="d-flex">
                  Select Limit :
                  <Form className="ms-3">
                    {['radio'].map((type) => (
                      <div key={`inline-${type}`} className="mb-3">
                        <Form.Check
                        inline
                        label="10"
                        name="group1"
                        type={type}
                        //checked={itemsPerPage == 10}
                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)}
                        id={`inline-${type}-1`}
                      >
                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(10)}checked={itemsPerPage == 10}/>
                        <Form.Check.Label >10</Form.Check.Label>
                      </Form.Check>
                      <Form.Check
                        inline
                        //label="25"
                        name="group1"
                        type={type}
                        //checked={itemsPerPage == 25}
                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)}
                        id={`inline-${type}-2`}
                      >
                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(25)} checked={itemsPerPage == 25}/>
                        <Form.Check.Label >25</Form.Check.Label>
                      </Form.Check>
                      <Form.Check
                        inline
                        label="50"
                        name="group1"
                        type={type}
                        //checked={itemsPerPage == 50}
                        //onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)}
                        id={`inline-${type}-3`}
                      >
                        <Form.Check.Input type="radio" style={{ cursor: 'pointer' }} onChange={(e) => e.target.value == "on" && itemPerChangeHandler(50)} checked={itemsPerPage == 50}/>
                        <Form.Check.Label >50</Form.Check.Label>
                      </Form.Check>
                      </div>
                    ))}
                  </Form>
                </div>
                <ReactPaginate
                  nextLabel=">>"
                  onPageChange={(e) => handlePageClick(e)}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  forcePage={selectedPage}
                  previousLabel="<<"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="pagination"
                  activeClassName="active"
                  renderOnZeroPageCount={null}
                />
              </div>
            )
          }
        </section> : null}
    </div>
  )
};

export default RoleMaster;